import {PaymentType} from '../../../../../enums/payment-type.enum';
import CheckingOrSavingsType from '../../../../../enums/CheckingOrSavingsType.enum';

export class DestinationBankAccountCreateDto {
  public usAbaRoutingNumber: string;
  public accountNumber: string;
  public paymentType: PaymentType;
  public checkingOrSavingsType: CheckingOrSavingsType;
}
